import { Box, Tooltip, Typography } from '@mui/material';
import { LINE_IMPACT } from '../../../lib/packingListEditImpact';

const COLOR_BY_KIND = { [LINE_IMPACT.UNALLOCATE]: '#ed6c02', [LINE_IMPACT.AUTO]: '#00647e' };

const labelSx = { fontSize: 11, width: '100%', textAlign: 'center' };

/**
 * 수정 모드 그리드의 배분 상태. 컨테이너에 실린 라인은 Allocated, 아닌 라인은 Unallocated로 보여준다.
 * Allocated에는 어느 컨테이너에 얼마나 실렸는지와, 고친 수량·단위가 배분에 주는 영향을 툴팁으로 보여주고, 배분이 풀릴 라인은 주황색이다.
 */
export default function AllocatedMarker({ marker }) {
    if (!marker?.allocated?.length) return <Typography sx={{ ...labelSx, color: 'text.disabled' }}>Unallocated</Typography>;
    const color = COLOR_BY_KIND[marker.kind] ?? '#2e7d32';
    const title = (
        <Box>
            <Typography sx={{ fontSize: 11, fontWeight: 600 }}>Allocated</Typography>
            {marker.allocated.map((a) => (
                <Typography key={a.number} sx={{ fontSize: 11 }}>{`${a.number} × ${a.qty.toLocaleString()}`}</Typography>
            ))}
            {marker.message && <Typography sx={{ fontSize: 11, mt: 0.5 }}>{marker.message}</Typography>}
        </Box>
    );
    return (
        <Tooltip title={title} arrow placement="right">
            <Typography sx={{ ...labelSx, color, fontWeight: 600 }}>Allocated</Typography>
        </Tooltip>
    );
}
